// plugins/deviceInfo.js
export default defineNuxtPlugin(async () => {    
  if (import.meta.client) {
    await setProperty()
  }
})

async function setProperty(callback) {
  console.log('setProperty~');

  const userAgent = navigator.userAgent;
  const lowerUserAgent = userAgent.toLowerCase();

  const mobileKeywords = [
    "android", "iphone", "ipod", "ipad", "blackberry",
    "windows ce", "samsung", "lg", "mot", "sonyericsson",
    "iemobile", "opera mini", "crios"
  ];

  let isMobile = "N";
  let isIphone = "N";

  for (const keyword of mobileKeywords) {
    if (lowerUserAgent.includes(keyword)) {
      isMobile = "Y";
      if (keyword.startsWith("ip")) {
        isIphone = "Y";
      }
      break;
    }
  }

  const isPwa =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: minimal-ui)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    ("standalone" in window.navigator && window.navigator.standalone === true);

  let coverGbnCd = "PCWEB";
  if (/appfactory/i.test(userAgent)) {
    coverGbnCd = "APP";
    isMobile = "Y";
  } else if (isMobile === "Y") {
    coverGbnCd = "MOBWEB";    
  } else if (isPwa) {
    coverGbnCd = "PWA";
  }

  sessionStorage.setItem("isMobile", isMobile);
  sessionStorage.setItem("isIphone", isIphone);
  sessionStorage.setItem("coverGbnCd", coverGbnCd);

  console.log('디바이스 정보 설정 완료:', { isMobile, isIphone, coverGbnCd });

  if (typeof callback === "function") {
    await callback();
  }
}